<template>
  <div class="app-navbar-actions">
    <!-- <ThemeSwitcher /> -->

    <!-- <VaButton
      v-if="!isMobile"
      preset="secondary"
      href="https://ui.vuestic.dev/support/consulting"
      target="_blank"
      color="textPrimary"
      class="app-navbar-actions__item flex-shrink-0 mx-0"
    >
      <VaIcon size="large" class="material-symbols-outlined mr-1">bolt</VaIcon>
    
    </VaButton> -->
    <!--
    <VaButton
      v-if="!isMobile"
      preset="secondary"
      href="https://admin.vuestic.dev/"
      target="_blank"
      color="textPrimary"
      class="app-navbar-actions__item flex-shrink-0 mx-0"
    >
      <VaIcon size="large" class="material-symbols-outlined mr-1">info</VaIcon>
      {{ t('aboutVuesticAdmin') }}
    </VaButton>
    <GithubButton v-if="!isMobile" class="app-navbar-actions__item" />
    <VaButton
      v-if="!isMobile"
      preset="secondary"
      href="https://discord.gg/u7fQdqQt8c"
      target="_blank"
      color="textPrimary"
      class="app-navbar-actions__item flex-shrink-0 mx-0"
    >
      <VaIcon :component="VaIconDiscord" />
    </VaButton> -->

    <!-- Desktop Region Indicator - COMMENTED OUT -->
    <!-- <UberRegionIndicator
      v-if="!isMobile"
      variant="compact"
      class="app-navbar-actions__item"
      @switchRegion="showRegionSelector = true"
    /> -->

    <!-- Mobile Region Indicator - COMMENTED OUT -->
    <!-- <UberRegionIndicator
      v-if="isMobile"
      variant="inline"
      class="app-navbar-actions__item app-navbar-actions__item--mobile-region"
      @switchRegion="showRegionSelector = true"
    /> -->

    <Bolt v-if="!isFinanceRole" class="app-navbar-actions__item" />
    <NotificationDropdown v-if="!isFinanceRole" class="app-navbar-actions__item" />
    <RecruitmentNotificationDropdown v-if="!isFinanceRole" class="app-navbar-actions__item" />
    <!-- ConsoleIcon hidden for now -->
    <!-- <ConsoleIcon class="app-navbar-actions__item" /> -->
    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile mr-1" />

    <!-- Region Selector Modal - COMMENTED OUT -->
    <!-- <VaModal v-model="showRegionSelector" title="Switch Uber Region" size="large" :ok-text="'Close'">
      <UberRegionSelector />
    </VaModal> -->
  </div>
</template>

<script lang="ts" setup>
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import NotificationDropdown from './dropdowns/NotificationDropdown.vue'
import RecruitmentNotificationDropdown from './dropdowns/RecruitmentNotificationDropdown.vue'
import GithubButton from './GitHubButton.vue'
import VaIconDiscord from '../../icons/VaIconDiscord.vue'
import ThemeSwitcher from '../../../pages/settings/theme-switcher/ThemeSwitcher.vue'
// import ConsoleIcon from './ConsoleIcon.vue' // hidden for now

defineProps({
  isMobile: { type: Boolean, default: false },
})

import { computed } from 'vue'
import Bolt from './dropdowns/Bolt.vue'
import { getUserRole } from '../../../utils/userRoleUtils'

// Hide driver status (Bolt), notifications, and recruitment icons for finance role
const isFinanceRole = computed(() => {
  const role = getUserRole()
  return role === 'finance' || role === 'finance-staff'
})
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}

/* Uber Region Indicator in Navbar */
.app-navbar-actions__item .uber-region-indicator {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 0.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.app-navbar-actions__item .uber-region-indicator:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.app-navbar-actions__item .region-indicator-compact {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.5rem 0.75rem;
  border-radius: 10px;
  backdrop-filter: blur(8px);
}

.app-navbar-actions__item .region-indicator-compact:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.app-navbar-actions__item .region-indicator-compact .region-flag {
  font-size: 1.1rem;
}

.app-navbar-actions__item .region-indicator-compact .region-name {
  color: white;
  font-size: 0.85rem;
  font-weight: 600;
}

.app-navbar-actions__item .region-indicator-compact .region-code {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.7rem;
  font-weight: 400;
}

.app-navbar-actions__item .region-indicator-compact .switch-button {
  font-size: 0.75rem;
  padding: 0.3rem 0.6rem;
  min-height: auto;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}

.app-navbar-actions__item .region-indicator-compact .switch-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

/* Mobile Region Indicator */
.app-navbar-actions__item--mobile-region {
  margin: 0 0.5rem;
}

.app-navbar-actions__item--mobile-region .region-indicator-inline {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 0.4rem 0.6rem;
  backdrop-filter: blur(8px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.app-navbar-actions__item--mobile-region .region-indicator-inline:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.app-navbar-actions__item--mobile-region .region-indicator-inline .region-flag {
  font-size: 0.9rem;
}

.app-navbar-actions__item--mobile-region .region-indicator-inline .region-name {
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
}

.app-navbar-actions__item--mobile-region .region-indicator-inline .region-code {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.65rem;
  font-weight: 400;
}

.app-navbar-actions__item--mobile-region .region-indicator-inline .switch-button {
  font-size: 0.7rem;
  padding: 0.25rem 0.4rem;
  min-height: auto;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}
</style>
